<template>
  <v-dialog v-model="isOpen" max-width="500">
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text>
        {{ message }}
      </v-card-text>
      <v-card-actions>
        <v-btn @click="resolvePromise(false)">{{ noText }}</v-btn>
        <v-btn color="primary" @click="resolvePromise(true)">{{ yesText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
      title: '',
      message: '',
      yesText: 'Yes',
      noText: 'No',
      promiseResolver: null
    }
  },
  methods: {
    openDialog({ title, message, yesText = 'Yes', noText = 'No' }) {
      this.title = title
      this.message = message
      this.yesText = yesText
      this.noText = noText
      this.isOpen = true
      return new Promise((resolve) => {
        this.promiseResolver = resolve
      })
    },
    resolvePromise(value) {
      this.isOpen = false
      if (this.promiseResolver) {
        this.promiseResolver(value)
      }
    }
  }
}
</script>
